const MeetingInfoBar = ({ currentTime }) => {
  return (
    <div className="absolute left-4 bottom-6 text-md text-white flex items-center">
      <span>{currentTime}</span>
    </div>
  )
}

export default MeetingInfoBar
